<template>
  <date-picker
    :value="modelValue"
    type="date"
    range
    format="DD.MM.YY"
    separator=" - "
    :placeholder="$t('History | filterDateDefault')"
    @update:value="updateDate"
  />
</template>

<script>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/locale/ru'
import 'vue-datepicker-next/locale/en'

export default {
  components: {
    DatePicker,
  },
  props: ['modelValue'],

  emits: ['update:modelValue'],

  computed: {
    date: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },

  methods: {
    updateDate(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>

<style lang="scss">
@import 'vue-datepicker-next/index.css';

.mx-datepicker-range {
  width: 100%;
}

.mx-input {
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 16px;
  height: unset;
  color: var(--text-3);
  background-color: var(--bg-1);
  border: 1px solid var(--bg-3);
  border-radius: 8px;
}

.mx-input:hover {
  border: 1px solid var(--bg-3);
}

.mx-input:focus {
  border: 1px solid var(--text-1);
}

.mx-input::placeholder {
  color: var(--text-1);
}

.mx-icon-clear,
.mx-icon-calendar,
.mx-icon-clear:hover,
.mx-icon-calendar:hover {
  color: var(--text-1);
  right: 21px;
}

.mx-datepicker-main {
  background-color: var(--bg-3);
  color: var(--text-1);
  border: none;
  border-radius: 8px;
  z-index: 99999 !important;
}

.mx-datepicker-popup {
  margin-top: 10px;
}

.mx-calendar + .mx-calendar {
  border-left: none;
}

.mx-btn {
  color: unset;
}
</style>
